import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

// Helpers
import showToast from "@/_lib/toast";

// Services and interfaces
import { UUID } from "@/interfaces/uuid/uuid";
import { useCopyRecipeMutation } from "@/repositories/recipe";

// Components
import Modal from "@/components/modal/modal";
import { ApiError } from "@/interfaces/api/error";


interface _CopyRecipeModalProps {
    open: boolean;
    onClose: () => void;
    recipe_id: UUID;
    name: string;
}

const CopyRecipeModal: FC<_CopyRecipeModalProps> = ({
    open,
    onClose,
    recipe_id,
    name
}) => {

    const { t } = useTranslation();
    const [copyRecipe, { isLoading }] = useCopyRecipeMutation();

    const handleCopy = () => {
        copyRecipe({ id: recipe_id, name }).unwrap().then(() => {
            showToast({type: 'success', title: t('notifications.recipe.copied.title'), message: t('notifications.recipe.copied.message', {name})});
            onClose();
        }).catch((error: ApiError) => {
            showToast({type: 'error', apiError: error.type})
        })
    }

    return (
        <Modal 
            open={open}
            onClose={onClose}
            title={t('modals.copyRecipe.title')}
            text={<Trans i18nKey="modals.copyRecipe.text" values={{ name }} />}
            action1={{
                label: t('components.buttons.copy'),
                loading: isLoading,
                onClick: handleCopy,
            }}
            cancel={{
                label: t('components.buttons.cancel'),
                disabled: isLoading,
                onClick: onClose
            }}
            sx={{'& .MuiPaper-root': {maxWidth: '480px'}}}
            />
    )
}

export default CopyRecipeModal;